module.exports = __webpack_public_path__ + "img/onlinePlatformTitle.369f4dc1.png";